import { render, staticRenderFns } from "./EventStatistics.vue?vue&type=template&id=0de6feac&"
import script from "./EventStatistics.vue?vue&type=script&lang=js&"
export * from "./EventStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports